var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./add.svg": "./src/icons/svg/add.svg",
	"./add2.svg": "./src/icons/svg/add2.svg",
	"./arrow-left.svg": "./src/icons/svg/arrow-left.svg",
	"./arrow-right.svg": "./src/icons/svg/arrow-right.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./data-platform.svg": "./src/icons/svg/data-platform.svg",
	"./desktop.svg": "./src/icons/svg/desktop.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./history.svg": "./src/icons/svg/history.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./iylogo.svg": "./src/icons/svg/iylogo.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./login.svg": "./src/icons/svg/login.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./mobile.svg": "./src/icons/svg/mobile.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./music.svg": "./src/icons/svg/music.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./notification-warning.svg": "./src/icons/svg/notification-warning.svg",
	"./operate-platform.svg": "./src/icons/svg/operate-platform.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./phone.svg": "./src/icons/svg/phone.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./refresh.svg": "./src/icons/svg/refresh.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./trash.svg": "./src/icons/svg/trash.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";